import { Component } from '@angular/core';
import { MailchimpAccount } from './mailchimp-account.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-mailchimp-accounts',
  templateUrl: './mailchimp-accounts.component.html',
  styleUrls: ['./mailchimp-accounts.component.css'],
})
export class AnalyticsMailchimpAccountsComponent extends SuperClass {
  accounts: any;

  selectedRow: MailchimpAccount;
  newAccount: MailchimpAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Mailchimp Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_MAILCHIMP_ACC] } },
        ],
      },
    ]);
    this.newAccount = new MailchimpAccount();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllAccounts('mailchimp', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new MailchimpAccount(e.data);
  }

  saveAccount() {
    const requiredFields = [
      { id: 'name', value: this.selectedRow.name, fieldName: 'Name' },
      { id: 'appId', value: this.selectedRow.apiKey, fieldName: 'App Id' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_updateAccounts(this.selectedRow, 'mailchimp', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new MailchimpAccount();
  }

  createNewAccount() {
    const requiredFields = [
      { id: 'new_name', value: this.newAccount.name, fieldName: 'Name' },
      { id: 'new_appId', value: this.newAccount.apiKey, fieldName: 'App Id' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_addAccount(this.newAccount, 'mailchimp', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'mailchimp', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/mailchimp-accounts/mailchimp-accounts.component.ts